import { TimelineBlock } from './cascade';

export interface LayoutBlock extends TimelineBlock {
  left: number;
  width: number;
}

export interface DeploymentBlock {
  id: string;
  start: string;
  end: string | null;
}

export const computeBlockLayout = (
  blocks: TimelineBlock[],
  timelineMin: number,
  timelineMax: number,
  containerWidthPx: number,
  minBlockPx = 12,
): LayoutBlock[] => {
  const span = timelineMax - timelineMin || 1;
  const toPx = (date: number) => ((date - timelineMin) / span) * containerWidthPx;

  const layout: LayoutBlock[] = blocks.map((block) => {
    const left = toPx(block.start);
    const right = toPx(block.end === null ? timelineMax : block.end);
    return { ...block, left, width: Math.max(right - left, 0) };
  });

  for (let i = 0; i < layout.length; i++) {
    if (layout[i].width < minBlockPx) {
      const deficit = minBlockPx - layout[i].width;
      layout[i].width = minBlockPx;
      for (let j = i + 1; j < layout.length; j++) {
        layout[j].left += deficit;
      }
    }
  }

  return layout;
};
